import './App.css';
import Navbar from './components/Navbar/Navbar';
import AllRoutes from './routes/AllRoutes';

function App() {
  return (
    <div className="App">
      <Navbar />
      <div className="page-margin-top">
        <AllRoutes />
      </div>
    </div>
  );
}

export default App;
